enum avatColors {
  red = "#c1002a",
  darkGrey = "#333",
  grey = "#797a7c",
  lightGrey = "#c4c9cd",
  veryLightGrey = "#F1F1F1"
}

export default avatColors;
